import React from 'react';
import { ButtonV2 } from '@zola/zola-ui';

function DeleteEventModal({ event, numRsvpResponses, onDeleteEvent, hideModalFn }) {
  // TODO: Add Seating Chart information here as the deletion is prevented for them as well.
  return (
    <div id="delete-event-modal">
      <div className="modal-header">
        <h3>Wait a sec!</h3>
      </div>
      <div className="modal-body">
        <p className="modal-copy">
          Are you sure you want to delete <strong>{event.name}</strong>? If you do, the event will
          be removed from your website and guests will no longer be able to RSVP online.
        </p>
        <p className="warning-copy">
          Any event info, RSVPs, meal preferences, and all other questions, will be DELETED.
        </p>
        {numRsvpResponses > 0 && (
          <p className="warning-copy">
            {numRsvpResponses} {numRsvpResponses > 1 ? "guests'" : "guest's"} RSVPs will be lost.
          </p>
        )}
        <div className="delete-modal-actions">
          <ButtonV2 variant="secondary" className="margin-right" onClick={onDeleteEvent}>
            Yes, Delete
          </ButtonV2>
          <ButtonV2 onClick={hideModalFn}>Cancel</ButtonV2>
        </div>
      </div>
    </div>
  );
}

export default DeleteEventModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/DeleteEventModal/DeleteEventModal.jsx